/*
 * @Author: your name
 * @Date: 2020-11-20 09:44:17
 * @LastEditTime: 2020-11-20 11:24:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zzll-gov-web-project\src\api\report\humDetail.js
 */
import request from "_private/utils/request";

//仓库温湿度动态明细监测点集合
export function FetchFindStorageHumDetailByPage(data) {
  return request({
    url: "/report/StorageHumitureDynamic/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 仓库温湿度明细charts数据
export function FetchStorageChartData(data) {
  return request({
    url: "/report/StorageHumitureDynamic/getDynamicInfoByLabelId",
    method: "post",
    headers: { type: "json" },
    data
  });
}

//门店温湿度动态明细监测点集合
export function FetchFindStoreHumDetailByPage(data) {
  return request({
    url: "/report/StoreHumitureDynamic/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

//门店温湿度动态明细
export function FetchStoreChartData(data) {
  return request({
    url: "/report/StoreHumitureDynamic/getDynamicInfoByLabelId",
    method: "post",
    headers: { type: "json" },
    data
  });
}

//冷藏车温湿度动态明细监测点集合
export function FetchFindrefrigVelHumDetailByPage(data) {
  return request({
    url: "/report/VehicleHumitureDynamic/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

//冷藏车温湿度动态明细
export function FetchFreezerChartData(data) {
  return request({
    url: "/report/VehicleHumitureDynamic/getDynamicInfoByLabelId",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 监测点下拉树
export function FetchTreeNode(data) {
  return request({
    url: "/report/vehicle/alarmDetail/getTreeNodeData",
    method: "post",
    data
  });
}

// 前置监测点下拉树
export function FetchLeadTreeNodeData(data) {
  return request({
    url: "/report/vehicle/alarmDetail/getLeadStorageTreeNodeData",
    method: "post",
    data
  });
}
